<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" sm="6">
                        <v-form ref="form" v-on:submit.prevent="SaveProduct">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="name" hide-details label="نام محصول"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                            نام محصول <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                 <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="weight" hide-details label="وزن محصول"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                            وزن محصول <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="properties" hide-details label="خواص محصول"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                            خواص محصول <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete @change="getCategory" :items="lang_items" :rules="[requireRule]" v-model="langSelected"
                                        hide-details label="انتخاب زبان" placeholder=" " dense outlined>
                                        <template #label>
                                            انتخاب زبان<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete :items="items" item-text="name" item-value="_id" :rules="[requireRule]" v-model="category"
                                        hide-details label="نام محصول" placeholder=" " dense outlined>
                                        <template #label>
                                            دسته بندی محصول <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                    <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <!-- @setImgUrl="getImgUrl" -->
                                    <v-btn @click="selectPhoto('main')" width="100%" v-bind="attrs" v-on="on">
                                       انتخاب عکس شاخص
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+image"></v-img>
                                    </v-card>
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                    <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <!-- @setImgUrl="getImgUrl" -->
                                    <v-btn @click="selectPhoto('product')" width="100%" v-bind="attrs" v-on="on">
                                       انتخاب عکس محصول
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+imgPath2"></v-img>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7"
                                        type="submit">ذخیره</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import BoxImages from '../../components/Images.vue'
    export default {
        props: ['product_id'],
        data() {
            return {
                name: '',
                loader: false,
                map: null,
                tileLayer: null,
                mapMarkers: [],
                weight : '',
                properties : '',
                imgPath: '',
                category: '',
                items: [],
                imgPath2: '',
                image: '',
                type: '',
                layers: [{
                    id: 0,
                    name: 'Requests',
                    active: true,
                    features: [],
                }, ],
                lang_items: [{
                    text: 'فارسی',
                    value: 'fa'
                }, {
                    text: 'انگلیسی',
                    value: 'en'
                }],
                langSelected:'fa',
                photoTypeSelected : ''
            }
        },
        components: {
            BoxImages
        },
        created() {
            if (this.product_id) {
                this.getProduct()
            }
            // else{
            //     this.getCategory()
            // }
        },
        methods: {
            selectPhoto(type){
                this.$refs.fileManager.dialog = true
                if(type == 'main'){
                    this.photoTypeSelected = 'main'
                }
                else{
                    this.photoTypeSelected = 'product'
                }
            },
            SaveProduct() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                var method = ''
                var url = ''
                if (this.product_id) {
                    method = 'put'
                    url = '/admin/product/edit/' + this.product_id
                } else {
                    method = 'post'
                    url = '/admin/product/add'
                }
                this.request({
                        method: method,
                        url: url,
                        data: {
                            name: this.name,
                            image_thumb: this.image,
                            category: this.category,
                            lang:this.langSelected,
                            weight : this.weight,
                            properties : this.properties,
                            image_product : this.imgPath2
                        }
                    })
                    .then((response) => {
                        //this.$refs.form.reset();
                        this.$notify({
                            title: 'انجام شد',
                            text: 'با موفقیت انحام شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.$router.push({
                            name: 'list_product'
                        })
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getProduct() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/product/single/' + this.product_id,
                    })
                    .then((response) => {
                        this.name = response.data.name,
                            this.image = response.data.image_thumb,
                            this.category = response.data.category._id
                            this.langSelected=response.data.lang
                            this.imgPath2 = response.data.image_product,
                            this.weight = response.data.weight,
                            this.properties = response.data.properties
                            this.getCategory()
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getCategory() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/category/product/select?lang='+this.langSelected
                    })
                    .then((response) => {
                        this.items = response.data
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getImgUrl(e) {
                if(this.photoTypeSelected == 'main'){
                    this.image = e
                }
                else{
                    this.imgPath2 = e
                }
            },
        }
    }
</script>

<style>

</style>
